
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.md?watch=parent';
    export const demoIndex = {
  ids: ["spreadsheet-demo-common","spreadsheet-demo-pivot","spreadsheet-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Spreadsheet" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.md?type=demo')
};